// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"39c45155","995":"8d2adb8c"}[chunkId] + ".chunk.css";
};